







import { Component, Prop } from "vue-property-decorator";
import { FollowUpStatus } from "@/core/constants";

import AppVue from "@/AppVue.vue";

@Component
export default class FollowUpStatusCpt extends AppVue {
  @Prop() text: string;
  @Prop() statusId: number;

  get badgeType() {
    switch (this.statusId) {
      case FollowUpStatus.NA:
        return "info";
      case FollowUpStatus.FollowupComplete:
      case FollowUpStatus.Closed:
        return "success";
      case FollowUpStatus.FollowupScheduled:
        return "primary";
      default:
        return "warning";
    }
  }
}
